import React, { useEffect, useRef, useState } from 'react'
import '../../assets/style/main.css'
import './style.scss'
import PageLoader from '../../components/PageLoader'
import { isPageLoading } from '../../components/PageLoader'
import CROSS_ICON from "../../assets/images/icons/x.png"
import SHIELD_ICON from "../../assets/images/icons/ShieldCheck.png"
import { Base_API } from '../../_actions/matcher'
import ContentLoader from '../../components/ContentLoader'
import { isContentLoading } from '../../components/ContentLoader'
import { EncryptedText, DecryptedText, EncryptedOBJ, DecryptedOBJ } from '../../utils/Encryption'
import moment from 'moment/moment'
import $ from 'jquery'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { NhealthAction } from '../../_actions/action.api'
const MySwal = withReactContent(Swal)
import CLOSE_ICON from '../../assets/images/icons/close-btn-2.png'
import { getHeadersAuthenLineId, getJWTbyPatientID, updateKYCPatient } from '../../_actions/sso.authen'
import useLineLogin from '../../_actions/authLine/lineLogin'
import lineConfig from '../../_actions/authLine/lineConfig'
import { getAllConsent, getContact, setConsent, setContact } from '../../_actions/econsent.connection'
import { ALERT } from '../../components/CustomAlert'

function SignUp_OTP() {
    let onceMount = useRef(true);
    let INPUT_OTP = useRef(null);

    const initialTimeLeft = 300;
    const [timeLeft, setTimeLeft] = useState(0);
    const [resendOTP, setResendOTP] = useState(false);
    const [regisInfo, setRegisInfo] = useState(null);
    const [otp, setOTP]= useState({
        otp: "",
        _refotp: "",
        _refverify: ""
    });
    const [otpBy, setOTPby] = useState(null); 
    const [JWT, setJWT] = useState(null);
    let [contactInfo, setContactInfo] = useState({
        "contact_id": "",
        "bu_code": "",
        "hn": "",
        "full_name": "",
        "date_of_birth": "",
        "gender": "",
        "nationality": "",
        "citizen_id": "",
        "passport_no": "",
        "email": "",
        "mobile": "",
        "unique_key": ""
    });

    const leadingZero = (num) => (num < 10 ? "0" + num : num);

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false;
        }
    }, [])

    useEffect(() => {
    
        const intervalId = setInterval(() => {
          setTimeLeft(timeLeft - 1);
        }, 1000);
    
        // Clear Count Time
        if (timeLeft === 0) {
          clearInterval(intervalId) 
          setResendOTP(true);
        }else
        {
          setResendOTP(false);
        }
    
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    const pageInit = async() => {
        await useLineLogin(lineConfig.signup_sso_verify);
        await jwtInit(); 
        let userData = await getRegisInfo(); 
        console.log('userData: ', userData);
        await otpInit();
        await checkCurrentURL();
        isPageLoading(false);
    }

    const jwtInit = () => {
        return new Promise(async resolve => {
            let raw_type_otp = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP);
            let dec_type_otp = DecryptedText(raw_type_otp)

            if(dec_type_otp === 'kyc')
            {
                await getJWT_Patient()
                .then(() => {
                    resolve();
                })
            }else // register
            {
                await getJWT()
                .then(() => {
                    resolve();
                })
            }
        })
    }

    const getJWT_Patient = () => {
        return new Promise(async resolve => {
            let ip = await NhealthAction.GetIPAdress();
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
            let patientID = patientData.data.patientid;
            console.log('patient: ',patientData);

            let reqData = {
                UserRef: patientID,
                IPAddress: ip,
                Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
            } 
            NhealthAction.JWT_Authen(reqData)
            .then(res => {
                console.log('jwt: ', res)
                if(!!res)
                {
                    setJWT(res);
                    localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                    resolve(res);
                }
            })
        })
    }
    const getJWT = () => {
        return new Promise(async resolve => {
            let ip = await NhealthAction.GetIPAdress();
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            console.log(lineProfile);
            let udid = lineProfile.user_id;

            if(!!lineProfile)
            {
                let reqData = {
                    UserRef: udid,
                    IPAddress: ip,
                    Channal: process.env.REACT_APP_ENC_NAME_CHANNEL_REF
                } 
                NhealthAction.JWT_Authen(reqData)
                .then(res => {
                    console.log('jwt: ', res)
                    if(!!res)
                    {
                        setJWT(res);
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_JWT_DATA, EncryptedOBJ(res));
                        resolve(res);
                    }
                })
            }else
            {
                console.error('Line profile is required!');
            }
        })
    }

    const otpInit = () => {
        return new Promise(async resolve => {
            let raw_otp_old_starttime = localStorage.getItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME);
        
            if (!!raw_otp_old_starttime) {
                let dec_otp_old_starttime = DecryptedText(raw_otp_old_starttime);
                let otpOldStartTime = moment(dec_otp_old_starttime, 'DD-MM-YYYY HH:mm:ss.SSS');
        
                let diffInMilliseconds = moment().diff(otpOldStartTime);
                let diffInSeconds = Math.floor(diffInMilliseconds / 1000);
        
                if (diffInSeconds < initialTimeLeft) {
                    // Continue countdown
                    let raw_otp_data = localStorage.getItem(process.env.REACT_APP_ENC_NAME_OTP_DATA);
                    let dec_otp_data = DecryptedOBJ(raw_otp_data);
            
                    setOTP({...otp, _refotp: dec_otp_data._refotp, _refverify: dec_otp_data._refverify});      
                    setTimeLeft(initialTimeLeft - diffInSeconds); // Set the remaining time in seconds
                } else {
                    // Reset countdown & Resend OTP
                    await getOTP();
                }
        
            } else {
                // Resend OTP
                console.log('OTP start time not present');
                await getOTP();
            }
      
            resolve();
        });
    };

    const getRegisInfo = () => {
        return new Promise(async resolve => {
            let raw_regis_info = localStorage.getItem(process.env.REACT_APP_ENC_NAME_REGIS_PAYLOAD);
            let raw_type_otp = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP);
            let dec_type_otp = DecryptedText(raw_type_otp)
            console.log('Type OTP: ', dec_type_otp);
            
            if(!!dec_type_otp && dec_type_otp === 'register')
            {
                let dec_regis_info = DecryptedOBJ(raw_regis_info);
                console.log('dec regis info: ', dec_regis_info);
                let receiver_data = {receiver: dec_regis_info.phone_number};
        
                setOTPby('phone_number');
                setRegisInfo(receiver_data);
                resolve(receiver_data);
            }
            if(!!dec_type_otp && dec_type_otp === 'kyc')
            {
                let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
                console.log('dec regis info: ', patientData);
                let receiver_data = {receiver: patientData.data.phonenumber};
        
                setOTPby('phone_number');
                setRegisInfo(receiver_data);
                resolve(receiver_data);
            }
            if(!!dec_type_otp && dec_type_otp === 'login')
            {
                let raw_type_signin = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_SIGNIN)
                let dec_type_signin = DecryptedText(raw_type_signin);
        
                if(dec_type_signin === "phone_number")
                {
                    let raw_user_phone = localStorage.getItem(process.env.REACT_APP_ENC_NAME_USER_PHONE);
                    let dec_user_phone = DecryptedOBJ(raw_user_phone);
                    let receiver_data = {receiver: dec_user_phone.phone_number};
            
                    setOTPby(dec_type_signin);
                    setRegisInfo(receiver_data);
                    resolve(receiver_data);
                }
                if(dec_type_signin === "email")
                {
                    let raw_user_email = localStorage.getItem(process.env.REACT_APP_ENC_NAME_USER_EMAIL);
                    let dec_user_email = DecryptedOBJ(raw_user_email);
                    let receiver_data = {receiver: dec_user_email.email};
            
                    setOTPby(dec_type_signin);
                    setRegisInfo(receiver_data);
                    resolve(receiver_data);
                }
            }
        })
    }

    const checkCurrentURL = () => {
        return new Promise(async resolve => {
            let enc_currentpage_url = localStorage.getItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL)
            let pathname = location.pathname;

            if(!!enc_currentpage_url)
            {
                let dec_currentpage_url = DecryptedText(enc_currentpage_url);
                if(pathname !== dec_currentpage_url)
                {
                    // set new
                    localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
                    localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
                    // navigate
                    location.reload();
                }
            }else
            {
                // set new
                localStorage.setItem(process.env.REACT_APP_ENCNAME_CURRENTPAGEURL, EncryptedText(pathname));
                localStorage.setItem(process.env.REACT_APP_ENCNAME_CAMEFROM_URL, EncryptedText(pathname));
            }
            resolve();
        })
    }

    const onChange = async(e) => {
        let value = e.target.value; 
        let length = value.length;

        setOTP({
            ...otp,
            otp: value
        }) 
        
        // clear style
        $(`.pin[index="1"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="2"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="3"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="4"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="5"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="6"]`).css({"border": "1px solid #E7E7E7"});  
        // clear input
        $(`.pin[index="1"]`).text("");  
        $(`.pin[index="2"]`).text("");  
        $(`.pin[index="3"]`).text("");  
        $(`.pin[index="4"]`).text("");  
        $(`.pin[index="5"]`).text("");  
        $(`.pin[index="6"]`).text("");  

        if(length > 0)
        {
            // let lastValue = value.slice(length-1, length);
            // $(`.pin[index="${length}"]`).text(lastValue);

            let value_split = value.split('');
            value_split.map((item, i) => {
                $(`.pin[index="${i+1}"`).text(item);
            })
        }

        if(length >= 6)
        {
            isContentLoading(true)

            // LocalStorage (Remove)
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME);
            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_OTP_DATA);

            let typeOTPEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP)
            let typeOTP = DecryptedText(typeOTPEnc)

            if(typeOTP === 'kyc')
            {
                await verifyOTP_SSO_KYC()
                .then(async(res) => {
                    console.log('verify otp: ', res);
                    await updateKYCPatient(res)
                    .then(() => {
                        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_CITIZENID_INVALID);
                        console.log('update kyc success!!')
                        location.href = `${Base_API.pathWeb}/n-health/kyc/success`;
                    })
                    .catch(statusCode => {
                        if(statusCode === "400_1")
                        {
                            localStorage.setItem(process.env.REACT_APP_ENC_NAME_UPDATE_KYC_CITIZENID_INVALID, EncryptedText('true'));
                            openAlertLink('ไม่สำเร็จ', 'หมายเลขบัตรประชาชนไม่ถูกต้อง', 'แก้ไข', `${Base_API.pathWeb}/n-health/kyc/step-1`);
                        } else if(statusCode === "400_2")
                        {
                            openAlertLink('ไม่สำเร็จ', 'ไฟล์อัพโหลดไม่ถูกต้อง', 'แก้ไข', `${Base_API.pathWeb}/n-health/kyc/step-4`);
                        } else
                        {
                            openAlertLink('ไม่สำเร็จ', 'เกิดข้อผิดพลาด', 'ตกลง', `${Base_API.pathWeb}/n-health/mycard`);
                        }
                    })
                })
            }
            if(typeOTP === 'register')
            {
                await verifyOTP_SSO()
                .then(async() => {
                    if(typeOTP === 'register')
                    {
                        // register sso
                        // if() | เช็คถ้ามีไม่ต้องสมัคร
                        if(checkSsoMember())
                        {
                            // register card member
                            // await cardMemberRegister()
                            // .then(() => {
                            // })
                            localStorage.removeItem(process.env.REACT_APP_ENC_NAME_IS_CARD_MEMBER);
                            // localStorage.removeItem('line_profile');
                            location.href = `${Base_API.pathWeb}/n-health/signup/connection`;
                        }else
                        {
                            await patientRegister()
                            .then(async() => {
                                // register card member
                                // await cardMemberRegister()
                                // .then(() => {
                                // })
                                localStorage.removeItem(process.env.REACT_APP_ENC_NAME_IS_CARD_MEMBER);
                                // localStorage.removeItem('line_profile');
                                location.href = `${Base_API.pathWeb}/n-health/signup/connection`;
                            })
                        }
                    }
                })
            }

        }else
        {
            $(`.pin[index="${length+1}"]`).css({"border": "2px solid #007AFF"});
        }
    }

    const checkSsoMember = () => {
        let userRes = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE)) : null; 
        if(!!userRes)
        {
            let isType = userRes.isType;
            if(isType === 2 || isType === 3)
            {
                return true; // is member
            }
            if(isType === 1)
            {
                return false; // is not member
            }
        }
    }

    const cardMemberRegister = () => {
        return new Promise(async resolve => {
            // เช็คก่อนว่าต้องสมัคร card member ไหม
            let isCardMember = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_IS_CARD_MEMBER) ? JSON.parse(DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_IS_CARD_MEMBER))) : false;
            if(isCardMember)
            {
                resolve();
            }else
            {
                let dataRegisEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_REGIS_PAYLOAD);
                let dataRegis = DecryptedOBJ(dataRegisEnc);
                let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
    
                let dob = String(dataRegis.dob).split('-').join('/');
    
                let reqData = {
                    Firstname: dataRegis.first_name_th,
                    Lastname: dataRegis.last_name_th,
                    Birthday: dob,
                    Phoneno: dataRegis.phone_number,
                    Email: dataRegis.email,
                    line_display: lineProfile.display_name,
                    line_profile: lineProfile.picture_url,
                    line_user: lineProfile.user_id,
                    line_token: lineProfile.id_token,
                    isinvite: false,
                    invite_line_user: "",
                }
                NhealthAction.RegisMember(reqData)
                .then(res => {
                    console.log("register card member: ", res);
                    if(res.isSuccess === true)
                    {
                        resolve();
                    }else
                    {
                        openAlert('ไม่สำเร็จ', res.errMessage, 'ตกลง');
                        //! bypass
                        // resolve(); // พี่นุ๊กเอา verify otp ในเส้น regis card member ออก ให้เอาตรงนี้ออกไป
                    }
                    // console.log(res);
                })
            }
        })
    }

    const patientRegister = () => {
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtData = await getJWT();
            
            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
            let dataRegisEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_REGIS_PAYLOAD);
            let typeRegisEnc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS)

            if(!!signin_data_enc && !!dataRegisEnc && !!typeRegisEnc)
            {
                let dataRegis = DecryptedOBJ(dataRegisEnc);
                let signInData = DecryptedOBJ(signin_data_enc);
                let typeRegis = DecryptedText(typeRegisEnc);
                let dob = dataRegis.dob.split('-');
                let gender = dataRegis.gender === 'female' ? 'F' : 'M'
                let identityPathURL = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL) ? localStorage.getItem(process.env.REACT_APP_ENC_NAME_IDCARD_IMAGE_URL) : "";

                console.log(dataRegis);

                let rawReq = {
                    "refEXP": signInData.refEXP,
                    "isType": signInData.isType,
                    "refAction": signInData.refAction,
                    "refType": signInData.refType,
                    "data": {
                        "identity_id": dataRegis.cardid,
                        "lasercode": dataRegis.back_idcard,
                        "isForeign": typeRegis === 'passport' ? true : false,
                        "name_th": dataRegis.first_name_th,
                        "surname_th": dataRegis.last_name_th,
                        "name_en": dataRegis.first_name_en,
                        "surname_en": dataRegis.last_name_en,
                        "identity_image": identityPathURL,
                        "ihuman_image": "",
                        "dob_day": Number(dob[0]),
                        "dob_month": Number(dob[1]),
                        "dob_year": Number(dob[2]),
                        "gender": gender,
                        "phonenumber": dataRegis.phone_number,
                        "email": dataRegis.email
                    },
                }
                let reqData = {
                    data: EncryptedOBJ(rawReq)
                }
                console.log('raw req (register): ', rawReq);

                NhealthAction.PatientRegis(reqData, headers)
                .then(async res => {
                    console.log('register sso member: ', res);
                    if(res.IsSuccess)
                    {
                        await handlerConsent(rawReq);
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res)) 
                        resolve();
                    }else
                    {
                        localStorage.clear();
                        openAlertLink('ไม่สำเร็จ', res.ErrMessage, 'ปิด', `${Base_API.pathWeb}/n-health/mycard`)
                    }
                })
            } 
        })
    }

    const handlerConsent = (patientInfo) => {
        return new Promise(async resolve => {
            try{
                let isShowConsent = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT) ? localStorage.getItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT) : null;
                //! เช็คว่าต้องทำ Consent ไหม?
                if(!!isShowConsent){
                    //? Group Data
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let udid = lineProfile.user_id;
                    let jwtData = await getJWT()
                    let headers = {
                        token: jwtData.token,
                        userRef: udid,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
                    let payload = {mobile: patientInfo.data.phonenumber}
                    let reqData = {data: EncryptedOBJ(payload)};
                    //! Check Consent ว่าเคยมีการทำ consent ไปแล้วไหม ?
                    await getContact(reqData, headers).then(async res => {
                        if(res.success === true){
                            let data = res.data;
                            if(!!data && data.length > 0){
                                //? เมื่อมีมากกว่า 0 ต้องนำ data ที่ได้มาเทียบกับเส้น get_all_consent ถ้ามีไม่ตรงกันก็ให้โชว์ consent 
                                let contactId = data[0].contact_id;
                                setContactInfo(data[0]);
                                //? เปรียบเทียบ consent
                                let compareStatus = await compareConsent(contactId).catch(() => resolve())
                                if(compareStatus === true){
                                    //! แมทช์แสดงว่าเคยทำไปแล้ว resolve ออกไปได้เลย
                                    resolve();
                                }else
                                {
                                    //? ไม่แมทช์ ต้องทำ consent โดยที่มี contact_id แล้ว แค่ set_consent อย่างเดียว
                                    await handlerSetConsent(patientInfo, contactId).catch(() => resolve());
                                    resolve();
                                }
    
                            }else{ //? ไม่เคยทำ consent ต้อง set_contact และ set_consent
                                await handlerSetConsent(patientInfo).catch(() => resolve())
                                resolve();
                            }
                        }else{
                            // ALERT.customAlert('เกิดข้อผิดพลาด', 'บริการไม่สามารถใช้งานได้ในขณะนี้ กรุณาติดต่อเจ้าหน้าที่', 'ตกลง');
                        }
                        console.log('get Contact: ', res); 
                    })
                }else resolve(); //! ไม่ต้องทำ Consent เพราะทำไปแล้ว
            }catch(err){
                console.log('Error: ', err);
                resolve();
            }
        })
    }
    const handlerSetConsent = async (patientInfo, contactId) => {
        return new Promise(async (resolve, reject) => {
            //? Group Contact Payload
            let contactPayload = {
                hn: "",
                title: "",
                first_name: patientInfo.data.name_th,
                middle: "",
                last_name: patientInfo.data.surname_th,
                date_of_birth: `${patientInfo.data.dob_year}-${patientInfo.data.dob_month}-${patientInfo.data.dob_day}`,
                gender: patientInfo.data.gender,
                nationality: patientInfo.data.isForeign ? "UNKHOWN" : "TH",
                citizen_id: patientInfo.data.isForeign ? "" : patientInfo.data.identity_id,
                passport_no: patientInfo.data.isForeign ? patientInfo.data.identity_id : "",
                passport_expire_date: "",
                email: patientInfo.data.email,
                mobile: patientInfo.data.phonenumber
            }
            let reqData = {
                data: EncryptedOBJ(contactPayload)
            }
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtData = await getJWT()
            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }
            //? Set Contact and Consent
            if(!!contactId){ //? ถ้ามี ContactId แสดงว่าไม่ต้องเซท contact ใหม่
                await handleSetConsent(contactId, patientInfo)
                resolve();
            }else{
                await setContact(reqData, headers)
                    .then(async contactRes => {
                        //! Set Contact Success
                        if (contactRes.success === true) {
                            await handleSetConsent(contactRes.data.contact_id, patientInfo);
                            resolve();
                        }else{
                            reject();
                            // ALERT.customAlert('เกิดข้อผิดพลาด', contactRes.message, 'ปิด');
                        }
                    })
            }
        })
    }
    const handleSetConsent = async(contact_id, patientInfo) => {
        return new Promise(async (resolve, reject) => {
            //? Group Consent Payload
            let consentPayload = {
                consent_date: moment().format('YYYY-MM-DD'),
                expire_date: "",
                contact_id: contact_id,
                consent: [
                    {
                        consent_key_type: "mobile_phone",
                        consent_key: contactInfo.mobile,
                        consent_channel_code: "nh_marketing_contact_call",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "mobile_phone",
                        consent_key: contactInfo.mobile,
                        consent_channel_code: "nh_marketing_contact_sms",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "email",
                        consent_key: contactInfo.email,
                        consent_channel_code: "nh_marketing_contact_email",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "hn",
                        consent_key: "",
                        consent_channel_code: "nh_data_sharing",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "citizen_id",
                        consent_key: patientInfo.data.isForeign === true ? "" : patientInfo.data.lab_identity_id,
                        consent_channel_code: "nh_data_sharing",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "passport_no",
                        consent_key: patientInfo.data.isForeign === true ? patientInfo.data.lab_identity_id : "",
                        consent_channel_code: "nh_data_sharing",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "email",
                        consent_key: contactInfo.email,
                        consent_channel_code: "nh_data_sharing",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "mobile_phone",
                        consent_key: contactInfo.mobile,
                        consent_channel_code: "nh_data_sharing",
                        consent_flag: true
                    }, 
                    {
                        consent_key_type: "hn",
                        consent_key: "",
                        consent_channel_code: "nh_lab_analysis_data",
                        consent_flag: true
                    },
                    {
                        consent_key_type: "citizen_id",
                        consent_key: patientInfo.data.isForeign === true ? "" : patientInfo.data.lab_identity_id,
                        consent_channel_code: "nh_lab_analysis_data",
                        consent_flag: true
                    },
                    {
                        consent_key_type: "passport_no",
                        consent_key: patientInfo.data.isForeign === true ? patientInfo.data.lab_identity_id : "",
                        consent_channel_code: "nh_lab_analysis_data",
                        consent_flag: true
                    }
                ]
            }
            let consentReqData = {
                data: EncryptedOBJ(consentPayload)
            }
            let consentJwtData = await getJWT();
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let consentHeaders = {
                token: consentJwtData.token,
                userRef: udid,
                authorizeRef: consentJwtData.authorizeRef,
                channalRef: consentJwtData.channalRef
            }
            await setConsent(consentReqData, consentHeaders)
                .then(consentRes => {
                    if (consentRes.success) {
                        //! Set Consent Success
                        localStorage.removeItem(process.env.REACT_APP_ENC_NAME_IS_SHOW_CONSENT); //? เอาไว้เช็คกับ flow register เพื่อให้ register รู้ว่าต้องทำ consent ไหม
                        resolve();
                    } else {
                        reject();
                        // ALERT.customAlert('เกิดข้อผิดพลาด', consentRes.message, 'ปิด');
                    }
                })
        })

    }
    const compareConsent = async(contactId) => {
        return new Promise(async (resolve, reject) => {
            let payload = { 
                contact_id: contactId,
                consent_channel_code: "nh_marketing_contact_call,nh_marketing_contact_sms,nh_marketing_contact_email,nh_data_sharing,nh_lab_analysis_data"
            }
            let reqData = {
                data: EncryptedOBJ(payload)
            }
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtData = await getJWT();
            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }
            await getAllConsent(reqData, headers)
            .then(res => {
                if(res.success === true){
                    if(res.data.length > 0){
                        let consentData = res.data.consent;
                        let data_1 = ["nh_marketing_contact_call","nh_marketing_contact_sms","nh_marketing_contact_email", "nh_data_sharing", "nh_lab_analysis_data"];
                        let data_2 = consentData.map(item => item.consent_channel_code); 
                        let compareStatus = compareArrays(data_1, data_2);
                        resolve(compareStatus);
                    }else throw Error('No data found');
                }else{
                    reject();
                    // ALERT.customAlert('เกิดข้อผิดพลาด', res.message, 'ปิด');
                }
            })
        })
        function compareArrays(arr1, arr2) {
            if (arr1.length !== arr2.length) {
              return false; // Arrays don't have the same length, so they can't be identical.
            }
          
            // Sort both arrays and check if all elements are the same.
            const sortedArr1 = [...arr1].sort();
            const sortedArr2 = [...arr2].sort();
          
            return sortedArr1.every((value, index) => value === sortedArr2[index]);
        }
    }

    const verifyOTP_SSO = () =>{
        return new Promise(async resolve => {
            let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            let udid = lineProfile.user_id;
            let jwtData = await getJWT();

            let headers = {
                token: jwtData.token,
                userRef: udid,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
            if(!!signin_data_enc)
            {
                let signInData = DecryptedOBJ(signin_data_enc);
                console.log(signInData);
                let rawReq = {
                    "refEXP": signInData.refEXP,
                    "isType": signInData.isType,
                    "refAction": signInData.refAction,
                    "refType": signInData.refType,
                    "_otp": INPUT_OTP.current.value,
                    "_refotp": otp._refotp,
                    "_refverify": otp._refverify
                }
                console.log('verify otp(raw req): ', rawReq);

                let reqData ={
                    "data": EncryptedOBJ(rawReq)
                }
    
                NhealthAction.verifyOTP_SSO(reqData, headers)
                .then(res => {
                    if(res.IsSuccess)
                    {
                        console.log('verify otp success: ', res)
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res)) 
                        resolve();
                    }else
                    {
                        openAlert('ไม่สำเร็จ', 'OTP ไม่ถูกต้อง', 'ลองอีกครั้ง');
                        setOTP({...otp, otp: ''}) 
                        // clear input
                        $(`.pin[index="1"]`).text("");  
                        $(`.pin[index="2"]`).text("");  
                        $(`.pin[index="3"]`).text("");  
                        $(`.pin[index="4"]`).text("");  
                        $(`.pin[index="5"]`).text("");  
                        $(`.pin[index="6"]`).text(""); 
                        isContentLoading(false);
                    }
                })
            }
        })
    }
    const verifyOTP_SSO_KYC = () =>{
        return new Promise(async resolve => {
            let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
            let patientID = patientData.data.patientid;
            let jwtData = await getJWT_Patient();

            let headers = {
                token: jwtData.token,
                userRef: patientID,
                authorizeRef: jwtData.authorizeRef,
                channalRef: jwtData.channalRef
            }

            if(!!patientData)
            {
                let rawReq = {
                    "refEXP": patientData.refEXP,
                    "isType": patientData.isType,
                    "refAction": patientData.refAction,
                    "refType": patientData.refType,
                    "_otp": INPUT_OTP.current.value,
                    "_refotp": otp._refotp,
                    "_refverify": otp._refverify
                }
                console.log('verify otp(raw req): ', rawReq);

                let reqData ={
                    "data": EncryptedOBJ(rawReq)
                }
    
                NhealthAction.verifyOTP_SSO(reqData, headers)
                .then(res => {
                    if(res.IsSuccess)
                    {
                        console.log('verify otp success: ', res)
                        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE, EncryptedOBJ(res)) 
                        resolve(res);
                    }else
                    {
                        openAlert('ไม่สำเร็จ', 'OTP ไม่ถูกต้อง', 'ลองอีกครั้ง');
                        setOTP({...otp, otp: ''}) 
                        // clear input
                        $(`.pin[index="1"]`).text("");  
                        $(`.pin[index="2"]`).text("");  
                        $(`.pin[index="3"]`).text("");  
                        $(`.pin[index="4"]`).text("");  
                        $(`.pin[index="5"]`).text("");  
                        $(`.pin[index="6"]`).text(""); 
                        isContentLoading(false);
                    }
                })
            }
        })
    }

    const onClickPin = () => {
        let length = $('input#otp').val().length;
        $(`.pin[index="${length+1}"]`).css({"border": "2px solid #007AFF"});
    }

    const onBlur = () => {
        // clear style
        $(`.pin[index="1"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="2"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="3"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="4"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="5"]`).css({"border": "1px solid #E7E7E7"});  
        $(`.pin[index="6"]`).css({"border": "1px solid #E7E7E7"});   
    }

    const reGetOTP = async() => { // ที่ต้อง duplicate function ทั้งที่มันทำงานเหมือนกัน เพราะ ตอนเข้าครั้งแรก state(phone number เซทไม่ทัน) // T.T
        if(resendOTP === true)
        {
            //! For Prod 
            setResendOTP(false);
            let otpData = await reSendOTP();
            if(!!otpData._refotp)
            {
                // Set Local Storage
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_DATA, EncryptedOBJ(otpData));
        
                // Set Count Time
                let currentTimestamp = moment().format('DD-MM-YYYY HH:mm:ss.SSS');
                let enc_currentTimestamp = EncryptedText(currentTimestamp);
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME, enc_currentTimestamp);
                setTimeLeft(initialTimeLeft);
        
                setOTP({...otp, _refotp: otpData._refotp, _refverify: otpData._refverify});      
            }else
            {
                if(otpData.ErrMessage === "maximum requested")
                {
                    openAlert("ผิดพลาด", "ไม่สามารถขอรหัส OTP ได้ในขณะนี้ กรุณาลองใหม่ภายหลัง");
                }
            }

            //! For Development 
            // Set Count Time
            // let currentTimestamp = moment().format('DD-MM-YYYY HH:mm:ss.SSS');
            // let enc_currentTimestamp = EncryptedText(currentTimestamp);
            // localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME, enc_currentTimestamp);
            // localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_DATA, EncryptedOBJ(otp));
            // setTimeLeft(initialTimeLeft);
        }
    }

    function reSendOTP()
    {
        return new Promise(async (resolve, reject) => {
            await sendOTPSMS()
            .then(res => {
                resolve(res);
            })
        });
    }

    const getOTP = async() => {
        return new Promise(async resolve => {
            let otpData = await sendOTP();
            if(!!otpData._refotp)
            {
                // Set Local Storage
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_DATA, EncryptedOBJ(otpData));
        
                // Set Count Time
                let currentTimestamp = moment().format('DD-MM-YYYY HH:mm:ss.SSS');
                let enc_currentTimestamp = EncryptedText(currentTimestamp);
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_OTP_START_TIME, enc_currentTimestamp);
                setTimeLeft(initialTimeLeft);
                setOTP({...otp, _refotp: otpData._refotp, _refverify: otpData._refverify});      
        
                resolve();
            }else
            {
                if(otpData.ErrMessage === "maximum requested")
                {
                    openAlert("ผิดพลาด", "ไม่สามารถขอรหัส OTP ได้ในขณะนี้ กรุณาลองใหม่ภายหลัง");
                }
                resolve();
            }
        })
    }

    function sendOTP()
    {
        return new Promise(async (resolve, reject) => {
            await sendOTPSMS()
            .then(res => {
                resolve(res);
            })
            // if(dec_type_otp === 'login')
            // {
            //     let raw_type_signin = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_SIGNIN)
            //     let dec_type_signin = DecryptedText(raw_type_signin);
        
            //     if(dec_type_signin === 'phone_number')
            //     {
            //         let phoneEnc = EncryptedText(receiver);
            //         let reqData = { "data" : phoneEnc } // = 1 (type number)
        
            //         await sendOTPSMS(reqData)
            //         .then(res => {
            //             resolve(res);
            //         })
            //     }
            //     if(dec_type_signin === 'email')
            //     {
            //         let emailEnc = EncryptedText(receiver);
            //         let reqData = { "data" : emailEnc } // = 1 (type number)
        
            //         await sendOTPEmail(reqData)
            //         .then(res => {
            //             resolve(res);
            //         })
            //     }
            // }
        })
    }

    const sendOTPSMS = () => {
        return new Promise(async resolve => {
            let raw_type_otp = localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_OTP);
            let dec_type_otp = DecryptedText(raw_type_otp);

            if(dec_type_otp === 'kyc')
            {
                let patientData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_PATIENT_PROFILE_DATA)) : null;
                let rawReq = {
                    "refEXP": patientData.refEXP,
                    "isType": patientData.isType,
                    "refAction": patientData.refAction,
                    "refType": patientData.refType
                }
                console.log('get otp(raw req): ', rawReq);
                let reqData = {
                    "data": EncryptedOBJ(rawReq)
                }

                let patientID = patientData.data.patientid;
                let jwtData = await getJWT_Patient();
                let headers = {
                    token: jwtData.token,
                    userRef: patientID,
                    authorizeRef: jwtData.authorizeRef,
                    channalRef: jwtData.channalRef
                }
                console.log(headers);
                
                NhealthAction.SendOTP_SMS_SSO(reqData, headers)
                .then(res => {
                    console.log('get otp: ', res);
                    if(res.IsSuccess)
                    {
                        resolve(res.data);
                    }else
                    {
                        if(res.ErrMessage === "maximum requested")
                        {
                            openAlert('ไม่สำเร็จ', 'ท่านขอหมายเลข OTP มากเกินในเวลาที่กำหนด กรุณารอทำรายการใหม่ในอีก 5 นาที', 'ตกลง');
                        }
                    }
                })
            }

            console.log('send otp (type otp): ',  dec_type_otp);
            if(dec_type_otp === 'register')
            {
                let signin_data_enc = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNIN_RESPONSE); 
                console.log('signin_data_enc: ', signin_data_enc);
                if(!!signin_data_enc)
                {
                    let signInData = DecryptedOBJ(signin_data_enc);
                    console.log('signInData: ', signInData);
                    let rawReq = {
                        "refEXP": signInData.refEXP,
                        "isType": signInData.isType,
                        "refAction": signInData.refAction,
                        "refType": signInData.refType
                    }
                    console.log('get otp(raw req): ', rawReq);
                    let reqData = {
                        "data": EncryptedOBJ(rawReq)
                    }
    
                    let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
                    let udid = lineProfile.user_id;
                    let jwtData = await getJWT();
                    let headers = {
                        token: jwtData.token,
                        userRef: udid,
                        authorizeRef: jwtData.authorizeRef,
                        channalRef: jwtData.channalRef
                    }
                    console.log(headers);
                    
                    NhealthAction.SendOTP_SMS_SSO(reqData, headers)
                    .then(res => {
                        console.log('get otp: ', res);
                        if(res.IsSuccess)
                        {
                            resolve(res.data);
                        }else
                        {
                            if(res.ErrMessage === "maximum requested")
                            {
                                openAlert('ไม่สำเร็จ', 'ท่านขอหมายเลข OTP มากเกินในเวลาที่กำหนด กรุณารอทำรายการใหม่ในอีก 5 นาที', 'ตกลง');
                            }
                        }
                    })
                }
            }
        })
    }
    const sendOTPEmail = (reqData) => {
        return new Promise(async resolve => {
            NhealthAction.SendOTP_Email_SSO(reqData)
            .then(res => {
                console.log('Send OTP Email: ', res);
                if(res.IsSuccess)
                {
                resolve(res.data);
                }
            })
        })
    }

    const handleResetClick = () => {
        // Resend OTP
        reGetOTP();
    };

    const handleInputChange = async(e) => {
        const input = e.target.value;
        const numericValue = input.replace(/\D/g, '');    
        setOTP({...otp, otp: numericValue})
    
        if(numericValue.length === 6)
        {
            await verifyOTP(numericValue)
            .then(() => {
                nextPage();
            }) 
            .catch(() => {
                openAlert('ไม่สำเร็จ', 'OTP ไม่ถูกต้อง', 'ลองอีกครั้ง');
            })
        }
    };

    function verifyOTP(OTP) {
        let raw_otp_data = localStorage.getItem(
            import.meta.env.VITE_DATA_ENC_NAME_OTP_DATA
        );
        let dec_otp_data = DecryptedOBJ(raw_otp_data);
    
        let rawReq = {
            _otp: OTP,
            _refotp: dec_otp_data._refotp,
            _refverify: dec_otp_data._refverify,
        };
        let reqData = {
            data: EncryptedOBJ(rawReq),
        };
    
        return new Promise(async (resolve, reject) => {
            APIS_ACTION.VerifyOTP(reqData).then((res) => {
                console.log(res);
                if (res.IsSuccess) {
                    localStorage.setItem(import.meta.env.VITE_DATA_ENC_NAME_REF_USER, EncryptedText(res.data.data));
                    resolve();
                }else
                {
                    reject();
                }
            });
        });
    }

    const openAlert = (title, body, button) => {
        let alertConfirmElem = (
            <div className="swal-cfpm">
                <div className="top">
                    <img onClick={handleCloseAlert} src={CLOSE_ICON} />
                </div>
        
                <div className="mid">
                    <h2 className="title">{title}</h2>
                    <p className="desc">
                        {body}
                    </p>
                </div>
        
                <div className={`bottom`}>
                    <button type="button" onClick={handleCloseAlert}>
                        {button}
                    </button>
                </div>
            </div>
        );
    
        MySwal.fire({
            html: alertConfirmElem,
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
        });
    
    };
    
    const openAlertLink = (title, body, button, href) => {
        let alertConfirmElem = (
          <div className="swal-cfpm">
            <div className="top">
              {/* <img
                onClick={handleCloseAlert}
                src="/images/icons/close-btn-2.png"
              /> */}
            </div>
  
            <div className="mid">
              <h2 className="title">{title}</h2>
              <p className="desc">{body}</p>
            </div>
  
            <div className={`bottom`}>
              <button type="button" onClick={() => window.location.href = href}>
                {button}
              </button>
            </div>
          </div>
        );
  
        MySwal.fire({
          html: alertConfirmElem,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
        });
    };

    const handleCloseAlert = () => {
        MySwal.close();
    };

    return (
        <div className='signup-otp-con'>
            <PageLoader />
            <ContentLoader />

            <div className="nav">
                <div className="close">
                    <img src={CROSS_ICON} />
                </div>
            </div> 
            <img src={SHIELD_ICON} className='cover' />

            <h2 className="title">
                ตรวจสอบเพื่อยืนยัน OTP
            </h2>
            <p className='sub-title'>เราได้ส่งรหัส OTP ผ่านทาง {otpBy === 'phone_number' ? 'SMS' : 'Email'} ไปยัง {otpBy === 'phone_number' ? 'เบอรโทรศัพท์' : ''} <br /> <span>{!!regisInfo && regisInfo.receiver}</span></p>

            <div className="pin-wrap">
                    <div className="pin-group">
                    <label htmlFor="otp" className='pin' index="1"></label>
                    <label htmlFor="otp" className='pin' index="2"></label>
                    <label htmlFor="otp" className='pin' index="3"></label>
                    <span>-</span>
                    <label htmlFor="otp" className='pin' index="4"></label>
                    <label htmlFor="otp" className='pin' index="5"></label>
                    <label htmlFor="otp" className='pin' index="6"></label>
                </div>

                <input 
                    type="number" 
                    id='otp' 
                    onChange={onChange} 
                    onBlur={onBlur}
                    value={otp.otp}
                    ref={INPUT_OTP}
                    onFocus={onClickPin}
                />
            </div>

            <p className="otp-ref">หมายเหตุ รหัส OTP : {otp._refotp}</p>
            <h3 className="time-count">
                {leadingZero(minutes)}:{leadingZero(seconds)}
            </h3>
            <p className={`resend ${resendOTP ? "" : "disabled"}`} onClick={resendOTP ? handleResetClick : null}>ส่งรหัส OTP อีกครั้ง</p>
        </div>
    )
}

export default SignUp_OTP